<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-10-18 11:03:41
 * @LastEditTime : 2025-06-09 09:07:21
 * @LastEditors  : yangxr
 * @Description  : 共享项目弹窗
 * @FilePath     : \icps_fb\src\views\ShareSystem\components\contract\projectDetail.vue
-->
<template>
    <div>
        <el-dialog :visible.sync="dialog" width="1000px" :close-on-click-modal="false" append-to-body :before-close="reset" @open="initData" >
            <span slot="title" class="dialog-title">共享项目</span>
            <div class="dialoginfo">
                <div style="margin-bottom: 20px;">
                    <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
                        <span style="margin-right: 15px;">共享项目编码:</span>
                        <el-input v-model="tableParams.code" style="width: 180px;margin-right: 15px;"  placeholder="请输入共享项目编码"></el-input>
                        <span style="margin-right: 15px;">共享项目名称:</span>
                        <el-input v-model="tableParams.name" style="width: 180px" placeholder="请输入共享项目名称"></el-input>
                        <el-button size="small" class="bottom_all" @click="initData">搜索</el-button>
                        <el-button size="small" class="bottom_one" @click="restParams">重置</el-button>
                    </div>
                </div>
                <div style="margin-bottom: 20px;">
                    <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark"  highlight-current-row @current-change="handleCurrentChange">
                      <template v-for="(item, index) in table">
                        <el-table-column v-if="item" :key="index"  :prop="item.prop" :label="item.label" :width="item.width" align="center" show-overflow-tooltip>
                          <template slot-scope="scope">
                            <span v-if="item.label == '序号'">
                              {{ scope.$index + 1 }}
                            </span>
                            <span v-else>{{ scope.row[item.prop] }}</span>
                          </template>
                        </el-table-column>
                      </template>
                    </el-table>
                </div>
                <div class="card_bottom" style="height:100%">
                    <div class="card_bottom_left">
                        <div class="top_page_totle">总共{{ total }}条</div>
                        <el-pagination :page-size="tableParams.pageSize" :page-sizes="[10, 20, 30, 40,50,100,200,500,1000]" layout="prev,pager,sizes,next,jumper" :total="total" :current-page.sync="tableParams.page" @size-change="sizeChange" @current-change="initData()"></el-pagination>
                    </div>
                    <div>
                        <el-button size="mini" class="bottom_all_two" @click="initData()">刷新</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="reset">关 闭</el-button>
                <el-button class="bottom_all" @click="submitProfit">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { cardLogin_HX,queryProject} from "@/views/ShareSystem/api/mainHx.js";
// import { alterContractProfitCenter, } from "@/api/contractManageApi";
export default {
    components: {
    },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        centerRow:{},
        saveType: {
            type: String,
            default: "",
        },
    },
    data(){
        return {
            tableParams:{
                page:1,
                pageSize:10,
                code:"",
                name:"",
                status:1,//只查询启用状态
            },
            accessToken:"",
            total:0,
            tableData:[],
            table:[
              { label: "序号", width: "80", prop: "id", status: true },
              { label: "共享项目编码", width: "auto", prop: "code", status: true },
              { label: "共享项目名称", width: "auto", prop: "name", status: true },
            //   { label: "税号", width: "auto", prop: "profitCenterAttributeName", status: true },
            ],
            currentRow:{},
            form:{},
        }
    },
    watch:{
        
    },

    methods:{
        async initData(){
          let that = this
          let res = await cardLogin_HX({ idCard: "pcms" })
            if (res.code == 1001) {
              let info = res.data;
              if (info && info.accessToken) {
                that.accessToken = info.accessToken
                this.queryProject();
              }
            }
        },
        restParams(){
           this.tableParams={
                page:1,
                pageSize:10,
                status:1,
                code:"",
                name:"",
            }
            this.initData();
        },
        queryProject(){
            if(this.centerRow){
                console.log(this.centerRow)
                this.tableParams.name = this.centerRow.profitCenterName
            }
            queryProject(this.tableParams,this.accessToken).then(res => {
                if(res.code == 1001) {
                    this.tableData = res.data.data
                    this.total = res.data.totalRows
                }
            })
        },
        handleCurrentChange(val){
            this.currentRow = val;
        },
        reset() {
            this.$emit("reset");
            this.restParams()
        },
        submitProfit(){
            if(Object.keys(this.currentRow).length === 0){
                this.$message.warning("请先选择一个共享项目！！！");
                return
            }else{
                if(this.saveType == 1){
                //     let params = {
                //   id: this.centerRow.id,
                //   profitCenterName:this.currentRow.name,
                //   profitCenterCode:this.currentRow.code,
                // }
                // alterContractProfitCenter( params).then(res => {
                //     if (res.code == 1001) {
                //         this.$message({ type: "success", message: res.codeMsg });
                //         this.$emit('reset')
                //     }
                // })
              }else{
                let params = {
                    shareProductName:this.currentRow.name,
                    shareProductCode:this.currentRow.code,
                }
                this.$emit("setCenterDetail",params)
              }
                this.reset();
            }
        },
        sizeChange(value) {
            this.tableParams.pageSize = value;
            this.initData();
        },
    }
}
</script>
<style lang="scss" scoped>
.addClass{
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}
.mr15{
  margin-right: 15px;
}
::v-deep .el-table__body tr.current-row > td {
    color: #fff;
    background: #00b85c !important;
}
</style>